import Router from './Router';
import Routes from './Routes';

export { Routes };
export default Router;
